module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('h1', [_vm._v("Resize the window to see the effect:")]), _vm._v(" "), _c('media', {
    attrs: {
      "query": {
        maxWidth: 800
      }
    },
    on: {
      "media-enter": _vm.maxWidth800,
      "media-leave": _vm.maxWidth800Leave
    }
  }, [_c('div', [_c('h2', {
    staticStyle: {
      "color": "orange"
    }
  }, [_vm._v(_vm._s(_vm.msg))]), _vm._v(" "), _c('h3', [_vm._v("horay!")])])]), _vm._v(" "), _c('media', {
    attrs: {
      "query": {
        minWidth: 800
      }
    },
    on: {
      "media-enter": _vm.minWidth800,
      "media-leave": _vm.minWidth800Leave
    }
  }, [_c('div', [_c('h2', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v(_vm._s(_vm.msg))]), _vm._v(" "), _c('h3', [_vm._v("oops!")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ab08fe8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./example/App.vue
// module id = 7
// module chunks = 0